import PaginationFilter from "@/filters/PaginationFilter";
import axios from "axios";
import Accordion from "@/components/Accordion";
import BaseFilter from "@/filters/BaseFilter";
import gsap from "gsap";
import LazyLoadController from "../components/LazyLoadController";

export default class AnnouncementsFilter extends BaseFilter {
    init() {
        this.announcementsWrapper = document.querySelector(
            ".js-announcements-wrapper",
        );

        if (this.announcementsWrapper) {
            let paginationFilter = new PaginationFilter();
            paginationFilter.initPagination("announcements");
        }
    }

    getFilters() {
        let filters = "";
        let announcementsWrapper = document.querySelector(
            ".js-announcements-wrapper",
        );
        let currentLanguage = this.getBodyElement().getAttribute(
            "data-current-language",
        );

        if (announcementsWrapper) {
            filters +=
                "&archive-url=" +
                encodeURIComponent(
                    announcementsWrapper.getAttribute("data-archive-url"),
                );
        }

        if (currentLanguage) {
            filters += "&current-language=" + currentLanguage;
        }

        return filters;
    }

    ajaxCall(page, stateHistory = true) {
        let url = this.getApiUrlFromElement(".js-announcements-wrapper");

        let params = "?page=" + page;
        let filters = this.getFilters();

        if (filters) {
            params += filters;
        }

        axios
            .get(this.getGlobalApiUrl() + "/" + url + params)
            .then((response) => {
                this.afterAjaxCall(response.data, stateHistory);
            });
    }

    afterAjaxCall(data, stateHistory) {
        if (data.html) {
            document.querySelector(".js-announcements-wrapper").innerHTML =
                data.html;
        }

        gsap.to(window, { duration: 0.5, scrollTo: 0 });

        if (data.url && stateHistory) {
            let stateData = {
                page: data.page,
                url: data.url,
                random: Math.random(),
                source: "swup",
            };

            this.updateUrls(stateData, data.url);
        }

        this.enableFilter();

        let paginationFilter = new PaginationFilter();
        paginationFilter.initPagination("announcements");

        let lazyLoadController = new LazyLoadController();
        lazyLoadController.init();

        new Accordion();
    }
}
